import React from 'react';
import PropTypes from 'prop-types';
import { Button as SUIButton } from 'semantic-ui-react';
import { ReactComponent as ChevronIcon} from '../../../assets/icons/arrow-right.svg'

import { styleUtils } from '../../utils';

import styles from './styles';
import {COLORS, COLORS_SEMANTIC_LIST} from "../../constants/design";

const { style } = styleUtils;

const IconStyle = {
  white: styles.iconWhite,
  seablue: styles.iconSeablue
};

const Button = ({
  colored,
  chevron,
  children,
  size,
  disabled,
  ...restOfProps
}) => {
  const componentStyle = styles[colored] || styles.seablue;
  const Component = style(SUIButton, componentStyle);


  if (chevron) {
    const componentIcon = IconStyle[colored] || IconStyle.seablue;
    const Icon = style(ChevronIcon, componentIcon);
    return (
      <Component
        icon
        labelPosition={chevron}
        width={size}
        disabled={disabled}
        {...restOfProps}
      >
        {children}
        <Icon name={`chevron ${chevron}`} />
      </Component>
    );
  }
  return (
    <Component width={size} disabled={disabled} {...restOfProps}>
      {children}
    </Component>
  );
};

Button.propTypes = {
  ...SUIButton.propTypes,
  colored: PropTypes.oneOf([COLORS.NEUTRAL.WHITE, COLORS.SEABLUE, ...COLORS_SEMANTIC_LIST]),
  size: PropTypes.oneOf(['small', 'normal']),
  chevron: PropTypes.oneOf(['left', 'right']),
  disabled: PropTypes.bool
};

Button.defaultProps = {
  colored: 'white',
  size: 'normal',
  disabled: false
};

export default Button;
